import { render, staticRenderFns } from "./json-editor.vue?vue&type=template&id=07d8b64a&scoped=true"
import script from "./json-editor.vue?vue&type=script&lang=js"
export * from "./json-editor.vue?vue&type=script&lang=js"
import style0 from "./json-editor.vue?vue&type=style&index=0&id=07d8b64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8b64a",
  null
  
)

export default component.exports